import type { FilterDefinition, FilterHandler } from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
  type SegmentedFilter,
} from '../types/filters';

export const multiSalaryDefinition: FilterDefinition<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  id: FilterId.MULTI_SALARY,
  name: 'Salary',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.SALARY,
  instances: [],
  isVisible: true,
};

export const multiSalaryHandler: FilterHandler<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  isActive(currentFilterState) {
    return currentFilterState.instances.length > 0;
  },
  isDefault(currentFilterState) {
    return currentFilterState.instances.length === 0;
  },
  getEffectiveFilter(currentFilterState) {
    return currentFilterState;
  },
};
